import { FadedImage } from "../../FadedImage";

const A = "/brand";
const IMG = `${A}/blueprint4joy-books-signing-chasing-fireflies-teal.jpg`;
const ALT = "Lara laughing while signing books at a table, teal blazer, a line of readers waiting behind her.";

export function ChasingFireflies() {
  return (
    <section data-testid="books-chasing-fireflies" className="relative overflow-hidden bg-[#FFFFFF]">
      <div className="relative w-full overflow-hidden reveal pb-10 lg:pb-0">
        {/* Desktop image half-band, left side */}
        <div className="hidden lg:block absolute inset-y-0 left-0 w-[48%]">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="books-chasing-fireflies-image"
            bg="#FFFFFF"
            objectPosition="35% 0%"
            featherRight={60}
            featherTop={10}
            featherBottom={10}
            fadeOpacity={0.4}
            className="absolute inset-0"
          />
        </div>

        {/* Mobile image stacked on top */}
        <div className="lg:hidden relative w-full aspect-[4/5] mt-2">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="books-chasing-fireflies-image-mobile"
            bg="#FFFFFF"
            objectPosition="35% 30%"
            featherBottom={20}
            className="absolute inset-0"
          />
        </div>

        {/* Text on the clean right */}
        <div className="relative z-[2] max-w-7xl mx-auto px-6 md:px-10 pt-8 lg:pt-[56px] flex items-start justify-end lg:min-h-[520px]">
          <div className="w-full lg:w-[52%]">
            <div className="max-w-[566px] lg:ml-auto">
              <h2
                data-testid="books-chasing-fireflies-header"
                className="font-display text-[34px] md:text-[44px] text-[#1C1917] leading-[1.15]"
              >
                Chasing Fireflies
              </h2>
              <p className="mt-[4px] mb-[8px] font-display text-xl md:text-2xl text-[#159E9A] leading-snug">
                Poetry for the parts of us still learning to see.
              </p>
              <div className="space-y-4 text-lg md:text-xl leading-[1.69] text-[#57534E]">
                <p>
                  Some moments are too quiet for a self-help book. They ask
                  for something gentler.
                </p>
                <p>
                  Chasing Fireflies is a collection of poems about grief,
                  hope, love, wonder, courage and the ordinary moments that
                  quietly change us.
                </p>
                <p>
                  Some pages feel like conversations. Others feel like
                  permission to slow down long enough to notice what has
                  been there all along.
                </p>
                <p>
                  It&rsquo;s the kind of book people leave on a nightstand,
                  tuck into a suitcase or return to whenever life feels
                  heavy and they need a small reminder that beauty still
                  exists.
                </p>
              </div>
              <div className="mt-8">
                <a
                  href="https://a.co/d/0dvpob89"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="books-chasing-fireflies-buy-link"
                  className="inline-flex items-center justify-center gap-2 bg-[#FF5A4F] text-white rounded-[8px] px-6 py-3 text-sm font-medium hover:bg-[#e8463c] transition-colors"
                >
                  Buy on Amazon
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
